export default __webpack_public_path__ + "2870af678597f3a89a803dfbbf2babf0.svg";